import React from "react";
import { Box, Typography } from "@mui/material";

const levels = ["None", "Mild", "Moderate", "Intense"];

const BodyMap = ({ selected, setSelected }) => {

    const handleClick = (part) => {
        const current = selected[part] || 0;
        const next = (current + 1) % 4;

        setSelected({
            ...selected,
            [part]: next,
        });
    };

    const getColor = (level) => {
        switch (level) {
            case 1:
                return "#c7e6e1"; // Mild
            case 2:
                return "#7cc4b8"; // Moderate
            case 3:
                return "#b39ddb"; // Intense
            default:
                return "#e5e7eb"; // None
        }
    };
    const hasSelected = Object.values(selected).some(v => v > 0);

    // 🔥 LABEL POSITIONS
    const labelPositions = {
        head: { left: 170, top: 10, label: "Head" },
        neck: { left: 20, top: 50, label: "Neck" },
        leftShoulder: { left: 0, top: 90, label: "Left Shoulder" },
        rightShoulder: { left: 170, top: 90, label: "Right Shoulder" },
        chest: { left: 170, top: 120, label: "Chest" },
        leftArm: { left: 0, top: 140, label: "Left Arm" },
        rightArm: { left: 170, top: 140, label: "Right Arm" },
        leftHand: { left: 0, top: 160, label: "Left Hand" },
        rightHand: { left: 170, top: 160, label: "Right Hand" },
        stomach: { left: 20, top: 180, label: "Stomach" },
        lowBack: { left: 170, top: 200, label: "Lower Back" },
        leftLeg: { left: 0, top: 260, label: "Left Leg" },
        rightLeg: { left: 170, top: 260, label: "Right Leg" },
        leftFoot: { left: 0, top: 320, label: "Left Foot" },
        rightFoot: { left: 170, top: 320, label: "Right Foot" },
    };

    return (
        <Box
            textAlign="center"
            mt={2}
            position="relative"
            sx={{
                "@keyframes bounce": {
                    "0%, 100%": {
                        transform: "translateX(-50%) translateY(0)",
                    },
                    "50%": {
                        transform: "translateX(-50%) translateY(-6px)",
                    },
                },
            }}
        >

            {/* BODY */}
            <svg width="220" height="360">

                {/* HEAD */}
                <ellipse cx="110" cy="30" rx="22" ry="26"
                    fill={getColor(selected.head)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("head")}
                />

                {/* NECK */}
                <rect x="100" y="55" width="20" height="18" rx="6"
                    fill={getColor(selected.neck)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("neck")}
                />

                {/* SHOULDERS */}
                <ellipse cx="70" cy="85" rx="22" ry="12"
                    fill={getColor(selected.leftShoulder)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("leftShoulder")}
                />
                <ellipse cx="150" cy="85" rx="22" ry="12"
                    fill={getColor(selected.rightShoulder)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("rightShoulder")}
                />

                {/* CHEST */}
                <ellipse cx="110" cy="110" rx="28" ry="22"
                    fill={getColor(selected.chest)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("chest")}
                />

                {/* ARMS */}
                <rect x="30" y="95" width="14" height="60" rx="8"
                    fill={getColor(selected.leftArm)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("leftArm")}
                />
                <rect x="176" y="95" width="14" height="60" rx="8"
                    fill={getColor(selected.rightArm)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("rightArm")}
                />

                {/* HANDS */}
                <ellipse cx="30" cy="165" rx="10" ry="14"
                    fill={getColor(selected.leftHand)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("leftHand")}
                />
                <ellipse cx="190" cy="165" rx="10" ry="14"
                    fill={getColor(selected.rightHand)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("rightHand")}
                />

                {/* STOMACH */}
                <ellipse cx="110" cy="150" rx="24" ry="20"
                    fill={getColor(selected.stomach)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("stomach")}
                />

                {/* LOWER BODY */}
                <ellipse cx="110" cy="185" rx="22" ry="16"
                    fill={getColor(selected.lowBack)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("lowBack")}
                />

                {/* LEGS */}
                <rect x="80" y="210" width="18" height="90" rx="10"
                    fill={getColor(selected.leftLeg)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("leftLeg")}
                />
                <rect x="122" y="210" width="18" height="90" rx="10"
                    fill={getColor(selected.rightLeg)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("rightLeg")}
                />

                {/* FEET */}
                <ellipse cx="88" cy="315" rx="14" ry="20"
                    fill={getColor(selected.leftFoot)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("leftFoot")}
                />
                <ellipse cx="132" cy="315" rx="14" ry="20"
                    fill={getColor(selected.rightFoot)}
                    stroke="#d1d5db"
                    strokeWidth="1.5"
                    onClick={() => handleClick("rightFoot")}
                />
            </svg>
            {!hasSelected && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 110,
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#fff",
                        px: 2,
                        py: 1,
                        borderRadius: "20px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: 13,
                        animation: "bounce 1.5s infinite",
                    }}
                >
                    👉 Tap any body area
                </Box>
            )}

            {/* 🔥 FLOATING LABELS */}
            {Object.keys(selected).map((key) => {
                const level = selected[key];

                if (!level || level === 0) return null;

                const pos = labelPositions[key];

                return (
                    <Box
                        key={key}
                        sx={{
                            position: "absolute",
                            left: pos.left,
                            top: pos.top,
                            background: "#fff",
                            px: 1.5,
                            py: 0.5,
                            borderRadius: "16px",
                            fontSize: 12,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                        }}
                    >
                        <Box
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                background: getColor(level),
                            }}
                        />
                        <Typography fontSize={12}>
                            {pos.label} — {levels[level]}
                        </Typography>
                    </Box>
                );
            })}

            {/* LEGEND */}
            <Box display="flex" justifyContent="center" gap={2} mt={1}>
                <Legend color="#e5e7eb" label="None" />
                <Legend color="#c7e6e1" label="Mild" />
                <Legend color="#7cc4b8" label="Moderate" />
                <Legend color="#b39ddb" label="Intense" />
            </Box>

            {/* COUNT FIX */}
           {/* COUNT FIX */}
<Typography mt={2} color="#6b7280">
  {Object.values(selected).filter((v) => v > 0).length === 0
    ? "No tension areas selected"
    : `${Object.values(selected).filter((v) => v > 0).length} tension ${
        Object.values(selected).filter((v) => v > 0).length === 1
          ? "area"
          : "areas"
      } selected`}
</Typography>

        </Box>
    );
};

const Legend = ({ color, label }) => (
    <Box display="flex" alignItems="center" gap={0.5}>
        <Box
            sx={{
                width: 12,
                height: 12,
                borderRadius: 1,
                background: color,
            }}
        />
        <Typography fontSize={12}>{label}</Typography>
    </Box>
);

export default BodyMap;
